/**
 * Componente Principal: App
 * Monedero Digital NFC
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toastify-custom.css';

// Contexts
import { AuthProvider } from './contexts/AuthContext';
import { NFCProvider } from './contexts/NFCContext';
import { TransactionProvider } from './contexts/TransactionContext';
import { ProductProvider } from './contexts/ProductContext';

// Components
import PrivateRoute from './components/common/PrivateRoute';

// Pages
import Login from './containers/Login';
import Dashboard from './containers/Dashboard';
import Payment from './containers/Payment';
import Recharge from './containers/Recharge';
import Balance from './containers/Balance';
import Transactions from './containers/Transactions';
import Products from './containers/Products';
import Scan from './containers/Scan';
import Write from './containers/Write';

import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <NFCProvider>
          <TransactionProvider>
            <ProductProvider>
              <div className="App">
                <Routes>
                  {/* Ruta pública */}
                  <Route path="/login" element={<Login />} />

                  {/* Rutas protegidas */}
                  <Route
                    path="/dashboard"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/payment"
                    element={
                      <PrivateRoute>
                        <Payment />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/recharge"
                    element={
                      <PrivateRoute>
                        <Recharge />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/balance"
                    element={
                      <PrivateRoute>
                        <Balance />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/transactions"
                    element={
                      <PrivateRoute>
                        <Transactions />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/products"
                    element={
                      <PrivateRoute>
                        <Products />
                      </PrivateRoute>
                    }
                  />

                  {/* Rutas de desarrollo (mantener por ahora) */}
                  <Route path="/scan" element={<Scan />} />
                  <Route path="/write" element={<Write />} />

                  {/* Redireccion por defecto */}
                  <Route path="/" element={<Navigate to="/login" />} />
                  <Route path="*" element={<Navigate to="/login" />} />
                </Routes>

                {/* Toast notifications */}
                <ToastContainer
                  position="top-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </div>
            </ProductProvider>
          </TransactionProvider>
        </NFCProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
